import * as React from 'react';
import { formatMessageBundle } from '@unifocus/js-utils';
import messages from '../../../localized-messages';
import { NavBarButton } from './NavBarButton';

/**
 * {@docCategory NavBar}
 */
export interface NavBarBackButtonProps {
   /**
    * The title of the button.
    * @defaultvalue Back
    */
   text?: string;

   /**
    * Called when the back button is clicked.
    */
   onClick: () => void;
}

export const NavBarBackButton = (props: NavBarBackButtonProps) => {
   return (
      <NavBarButton onClick={props.onClick}>
         {props.text || formatMessageBundle(messages, 'res_back')}
      </NavBarButton>
   );
};
